import React from "react";
import WeatherIcon from "./WeatherIcon";

export default function WeatherForecastComp(props) {
  return (
    <div className="weatherForecastCom col">
      {new Date(props.forecast.dt * 1000).getHours()}:00
      <WeatherIcon iconNum={props.forecast.weather[0].icon} />
      {Math.round(props.forecast.main.temp)}°C
    </div>
  );
}
